





















































































































































































































































import Vue from 'vue';
import TopNav from '@/web/components/navigation/TopNav.vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import { notify } from '@/web/utils/notify';
import { saveAs } from '@/web/utils/save-file';
import { formatDate } from '@/web/utils/format';
import { mapGetters } from 'vuex';
import CancelCustomerOrderModal from '@/web/components/customers/CancelCustomerOrderModal.vue';
import PauseCustomerOrderModal from '@/web/components/customers/PauseCustomerOrderModal.vue';
import ResumeCustomerOrderModal from '@/web/components/customers/ResumeCustomerOrderModal.vue';
import ModifyExpirationCustomerOrderModal from '@/web/components/customers/ModifyExpirationCustomerOrderModal.vue';
import PaymentPlanInvoicesModal from '@/web/components/payment-plans/PaymentPlanInvoicesModal.vue';
import ModifyOrderModal from '@/web/components/customers/ModifyOrderModal.vue';

interface LocalState {
  search: string;
  date: DatePicker;
  tableFields: PaginatedTableField[];
}

export default Vue.extend({
  name: 'Orders',
  components: {
    TopNav,
    NavItem,
  },
  async mounted() {
    await this.$store.dispatch('sale/getSalesPurchaseStats');
  },
  data(): LocalState {
    return {
      search: '',
      date: {
        startDate: new Date(),
        endDate: new Date(),
      },
      tableFields: [
        {
          title: this.$t('ORDERS.TABLE.NAME') as string,
          name: 'customer_full_name',
          cssClass: 'h5 m-0',
          ordering: 'student__first_name',
        },
        {
          title: this.$t('ORDERS.TABLE.EMAIL') as string,
          key: 'customer.email',
          cssClass: 'h5 m-0',
          ordering: 'student__email',
        },
        {
          title: this.$t('ORDERS.TABLE.PRODUCT') as string,
          name: 'product_name',
          cssClass: 'h5 m-0',
          ordering: 'product__product_name',
        },
        {
          name: 'created',
          title: this.$t('ORDERS.TABLE.PURCHASE_DATE') as string,
          ordering: 'created',
        },
        {
          name: 'expires_at',
          title: this.$t('ORDERS.TABLE.EXPIRY_DATE') as string,
        },
        {
          name: 'status',
          title: this.$t('ORDERS.TABLE.STATUS') as string,
          cssClass: 'h5 m-0',
        },
        {
          name: 'is_payment_plan',
          title: '',
          cssClass: 'h5 m-0',
        },
        {
          name: 'amount_paid',
          title: this.$t('ORDERS.TABLE.AMOUNT') as string,
          ordering: 'amount_paid',
        },
        {
          name: 'tax_amount',
          title: this.$t('ORDERS.TABLE.TAX') as string,
        },
        {
          name: 'edit',
          shrink: true,
          cssClass: 'p-0',
          disableClick: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      salesPurchaseStat: 'sale/salesPurchaseStat',
    }),
    query(): {} {
      return {
        q: this.search,
      };
    },
    showEmpty(): boolean {
      const ordersTable = this.$store.state['orders-table'];
      if (ordersTable) {
        return ordersTable.perPage === 0 && !ordersTable.isLoading;
      }
      return false;
    },
  },
  methods: {
    selectOrder() {
      console.log('selectOrder');
    },
    formatDate(date: string): string {
      if (!date) return '';
      return formatDate(date, 'date-time');
    },
    formatStatus(order: SalesPurchaseResponse, lowerCase = false): string {
      let status = order.new_order
        ? this.$t('ORDERS.STATUS.NEW')
        : order.returning
        ? this.$t('ORDERS.STATUS.RETURNING')
        : this.$t('ORDERS.STATUS.ACTIVE');
      if (!order.customer.is_active) {
        if (order.customer.is_paused) {
          status = this.$t('ORDERS.STATUS.PAUSED');
        } else {
          status = this.$t('ORDERS.STATUS.REMOVED');
        }
      } else if (order.customer.is_active && order.customer.is_canceled) {
        status = this.$t('ORDERS.STATUS.CANCELED');
      }
      if (order.is_gift) {
        status = this.$t('ORDERS.STATUS.GIFT');
      }
      return lowerCase ? status.toLowerCase() : status;
    },
    async exportAll(): Promise<void> {
      const table = this.$refs['orders-table'] as any;
      const data = await this.$store.dispatch('sale/exportOrders', {
        q: this.search,
        ordering: `${table.orderingDirection}${table.ordering}`,
      });
      const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
      saveAs(blob, 'orders-export.csv');
    },
    async viewCustomer(order: SalesPurchaseResponse): Promise<void> {
      this.$router.push(`/customers/${order.customer.id}`);
    },
    async modifyOrder(order: SalesPurchaseResponse): Promise<void> {
      console.log('modifying order', order);
      const table = this.$refs['orders-table'] as any;
      this.$modal.show(
        ModifyOrderModal,
        {
          order,
        },
        null,
        {
          'before-close': () => table.refresh(),
        }
      );
    },
    async downloadInvoice(order: SalesPurchaseResponse): Promise<void> {
      const data = await this.$store.dispatch('sale/downloadInvoice', order);
      const blob = new Blob([data], { type: 'application/pdf;charset=utf-8;' });
      saveAs(blob, `${order.product.product_name}.pdf`);
    },
    async pauseOrder(order: SalesPurchaseResponse): Promise<void> {
      const table = this.$refs['orders-table'] as any;
      this.$modal.show(PauseCustomerOrderModal, { orderId: order.id }, null, {
        'before-close': () => table.refresh(),
      });
    },
    async resumeOrder(order: SalesPurchaseResponse): Promise<void> {
      const table = this.$refs['orders-table'] as any;
      this.$modal.show(ResumeCustomerOrderModal, { orderId: order.id }, null, {
        'before-close': () => table.refresh(),
      });
    },
    async cancelOrder(
      order: SalesPurchaseResponse,
      terminate: boolean
    ): Promise<void> {
      const table = this.$refs['orders-table'] as any;
      this.$modal.show(
        CancelCustomerOrderModal,
        { orderId: order.id, terminate },
        null,
        {
          'before-close': () => table.refresh(),
        }
      );
    },
    async modifyExpiration(order: SalesPurchaseResponse): Promise<void> {
      const table = this.$refs['orders-table'] as any;
      this.$modal.show(
        ModifyExpirationCustomerOrderModal,
        {
          orderId: order.id,
          expirationDate: order.expires_at,
        },
        null,
        {
          'before-close': () => table.refresh(),
        }
      );
    },
    selectPaymentPlan(paymentPlan) {
      this.$modal.show(PaymentPlanInvoicesModal, {
        paymentPlan,
        refreshFn: () => {
          this.$refs['orders-table'].refresh();
        },
      });
    },
  },
});
